import React from 'react';
import PropTypes from 'prop-types';

import WarningIcon from '../../containers/WarningIcon';

const NoStudyMessage = ({ message }) => (
  <div className="no-study-message">
    <WarningIcon />
    <p>{message}</p>
  </div>
);

NoStudyMessage.propTypes = {
  message: PropTypes.string,
};

export default NoStudyMessage;
